module.exports = __webpack_public_path__ + "static/media/destination.c072003b.svg";